import Vue from 'vue'
import App from './App.vue'
import NavBarVuetify from './components/NavBarVuetify.vue'
import ErrorDialog from './components/ErrorDialog.vue'
import ResultsDialog from './components/ResultsDialog.vue'
import SSCLoader from './components/SSCLoader.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.component("nav-bar-vuetify", NavBarVuetify)
Vue.component("error-dialog", ErrorDialog)
Vue.component("results-dialog", ResultsDialog)
Vue.component("ssc-loader", SSCLoader)

Vue.use(require('vue-moment'))

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
